import { GetNewGuid } from "../../helpers/GuidHelper";

export enum VariableType {
  Boolean = "boolean",
  String = "string",
  Number = "number",
  BuiltIn = "builtIn",
}

export enum VariableScope {
  Public = "public",
  Sequence = "sequence",
  Take = "take",
}

export interface Variable {
  id: string; // GUID for stable references across renames
  type: VariableType;
  value: boolean | string | number;
  name: string; // User-facing variable name
  scope: VariableScope; // Default: "public"
}

export const createVariable = (
  name: string,
  type: VariableType,
  value: boolean | string | number,
  scope: VariableScope = VariableScope.Public
): Variable => {
  return {
    id: GetNewGuid(),
    name,
    type,
    value,
    scope,
  };
};

/**
 * Duplicates a variable with a new ID and optionally a new name.
 * If the new name would conflict with existing variables, appends a number.
 */
export const duplicateVariable = (
  variable: Variable,
  existingVariables: Variable[],
  nameSuffix: string = " Copy"
): Variable => {
  let newName = variable.name + nameSuffix;
  let counter = 1;

  // Ensure unique name
  while (existingVariables.some((v) => v.name === newName)) {
    newName = `${variable.name}${nameSuffix} ${counter}`;
    counter++;
  }

  return {
    ...variable,
    id: GetNewGuid(),
    name: newName,
  };
};
